import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TestimonialCard = () => {
  const testimonial = {
    text: "HungryElph connected me with amazing local chefs. The food quality is outstanding and the custom cake I ordered for my daughter\'s birthday was perfect!",
    author: 'Sarah Mitchell',
    role: 'Regular Customer',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ad9e1013-1763294640440.png",
    avatarAlt: 'Professional headshot of Caucasian woman with shoulder-length brown hair wearing blue blouse smiling warmly',
    rating: 5
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 md:p-8">
      <div className="flex gap-1 mb-4">
        {[...Array(testimonial?.rating)]?.map((_, index) =>
        <Icon
          key={index}
          name="Star"
          size={18}
          color="var(--color-warning)"
          className="fill-current" />

        )}
      </div>
      <p className="text-base md:text-lg text-foreground mb-6 leading-relaxed">
        "{testimonial?.text}"
      </p>
      <div className="flex items-center gap-4">
        <Image
          src={testimonial?.avatar}
          alt={testimonial?.avatarAlt}
          className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover" />

        <div>
          <p className="font-heading font-semibold text-base md:text-lg">
            {testimonial?.author}
          </p>
          <p className="text-sm text-muted-foreground">
            {testimonial?.role}
          </p>
        </div>
      </div>
    </div>);

};

export default TestimonialCard;